import { WriterHeaderProps } from './Types'
import { ArticleView } from 'types'
import { CanView } from 'components/Can'
import { WriterToolbar } from 'components/WriterToolbar/WriterToolbar'
import { MobileWriterTopBar } from 'blaze-components/MobileWriterTopBar/MobileWriterTopBar'
import { Header } from './Header'
import Styles from './MobileWriterHeader.module.scss'

export const MobileWriterHeader = ({ workspace }: WriterHeaderProps) => (
  <Header data-testid="writer-header" className={Styles.header}>
    <CanView inWorkspace={workspace.id} inViewMode={[ArticleView.Commenting, ArticleView.Reading]}>
      <MobileWriterTopBar workspace={workspace} />
    </CanView>
    <CanView inWorkspace={workspace.id} inViewMode={ArticleView.Editing}>
      <WriterToolbar />
    </CanView>
  </Header>
)
